var map = {
	"./magCpns.vue": "42e56",
	"./msgCard.vue": "8d0b",
	"./msgGoods.vue": "0bea",
	"./msgGoodsAsk.vue": "99e7",
	"./msgGoodsStore.vue": "518c",
	"./msgHistory.vue": "3696",
	"./msgImage.vue": "3f8a",
	"./msgLogistics.vue": "f023",
	"./msgOrder.vue": "c1ac",
	"./msgOrderAsk.vue": "4ec8",
	"./msgText.vue": "6ecd",
	"./msgVideo.vue": "e7a4"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) { // check for number or string
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return id;
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "7d1b";